// import React from 'react';
// import { Routes, Route } from 'react-router-dom'; // Remove BrowserRouter
// //import HomePage from './HomePage';
// import SportsPage from './pages/SportsPage';
// import { SportDetailPage } from './pages/SportDetailPage';


// function App() {
//   return (
//     // Remove <Router> wrapper since it's already in main.jsx
//     <Routes>
//       <Route path="/" element={<SportsPage />} />
//       <Route path="/sports" element={<SportsPage />} />
//       <Route path="/sports/:sportId" element={<SportDetailPage />} />
//     </Routes>
//   );
// }

// export default App;

// frontend/src/App.jsx
import React, { Suspense, lazy } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { Toaster } from 'react-hot-toast';
import { AuthProvider } from './contexts/AuthContext';
import ProtectedRoute from './components/Auth/ProtectedRoute';
import CoachRoute from './components/Auth/CoachRoute';
import AdminRoute from './components/Auth/AdminRoute';
import MainLayout from './components/Layout/MainLayout';
import LoadingSpinner from './components/Common/LoadingSpinner';
import './App.css';

// Lazy load pages for better performance
const HomePage = lazy(() => import('./pages/HomePage'));
const LoginPage = lazy(() => import('./pages/LoginPage'));
const RegisterPage = lazy(() => import('./pages/RegisterPage'));
const SportsPage = lazy(() => import('./components/Sports/SportsPage'));
const SportDetailPage = lazy(() => import('./components/Sports/SportDetailPage'));
const CoachDashboard = lazy(() => import('./components/Coach/CoachDashboard'));
const CoachProfilePage = lazy(() => import('./pages/CoachProfilePage'));
const AddOfferingPage = lazy(() => import('./pages/AddOfferingPage'));
const EditOfferingPage = lazy(() => import('./pages/EditOfferingPage'));
const MyOfferingsPage = lazy(() => import('./pages/MyOfferingsPage'));
const UserProfilePage = lazy(() => import('./pages/UserProfilePage'));
const BookingsPage = lazy(() => import('./pages/BookingsPage'));
const BookingDetailPage = lazy(() => import('./pages/BookingDetailPage'));
const FacilitiesPage = lazy(() => import('./pages/FacilitiesPage'));
const FacilityDetailPage = lazy(() => import('./pages/FacilityDetailPage'));
const AboutPage = lazy(() => import('./pages/AboutPage'));
const ContactPage = lazy(() => import('./pages/ContactPage'));
const PrivacyPolicyPage = lazy(() => import('./pages/PrivacyPolicyPage'));
const TermsPage = lazy(() => import('./pages/TermsPage'));
const NotFoundPage = lazy(() => import('./pages/NotFoundPage'));

// Admin pages
const AdminDashboard = lazy(() => import('./pages/admin/AdminDashboard'));
const AdminUsersPage = lazy(() => import('./pages/admin/AdminUsersPage'));
const AdminCoachesPage = lazy(() => import('./pages/admin/AdminCoachesPage'));
const AdminOfferingsPage = lazy(() => import('./pages/admin/AdminOfferingsPage'));
const AdminBookingsPage = lazy(() => import('./pages/admin/AdminBookingsPage'));
const AdminFacilitiesPage = lazy(() => import('./pages/admin/AdminFacilitiesPage'));
const AdminSettingsPage = lazy(() => import('./pages/admin/AdminSettingsPage'));

function App() {
  return (
    <Router>
      <AuthProvider>
        <MainLayout>
          <Suspense fallback={<LoadingSpinner fullScreen />}>
            <Routes>
              {/* Public Routes */}
              <Route path="/" element={<HomePage />} />
              <Route path="/login" element={<LoginPage />} />
              <Route path="/register" element={<RegisterPage />} />
              <Route path="/sports" element={<SportsPage />} />
              <Route path="/sports/:sportId" element={<SportDetailPage />} />
              <Route path="/coaches/:coachId" element={<CoachProfilePage />} />
              <Route path="/facilities" element={<FacilitiesPage />} />
              <Route path="/facilities/:facilityId" element={<FacilityDetailPage />} />
              <Route path="/about" element={<AboutPage />} />
              <Route path="/contact" element={<ContactPage />} />
              <Route path="/privacy" element={<PrivacyPolicyPage />} />
              <Route path="/terms" element={<TermsPage />} />
              
              {/* Protected Routes - Authenticated Users */}
              <Route element={<ProtectedRoute />}>
                <Route path="/profile" element={<UserProfilePage />} />
                <Route path="/bookings" element={<BookingsPage />} />
                <Route path="/bookings/:bookingId" element={<BookingDetailPage />} />
                
                {/* Coach Routes */}
                <Route element={<CoachRoute />}>
                  <Route path="/coach/dashboard" element={<CoachDashboard />} />
                  <Route path="/coach/profile/edit" element={<CoachProfilePage editMode />} />
                  <Route path="/coach/offerings/new" element={<AddOfferingPage />} />
                  <Route path="/coach/offerings/:offeringId/edit" element={<EditOfferingPage />} />
                  <Route path="/coach/offerings" element={<MyOfferingsPage />} />
                </Route>
              </Route>
              
              {/* Admin Routes */}
              <Route element={<AdminRoute />}>
                <Route path="/admin" element={<AdminDashboard />} />
                <Route path="/admin/users" element={<AdminUsersPage />} />
                <Route path="/admin/coaches" element={<AdminCoachesPage />} />
                <Route path="/admin/offerings" element={<AdminOfferingsPage />} />
                <Route path="/admin/bookings" element={<AdminBookingsPage />} />
                <Route path="/admin/facilities" element={<AdminFacilitiesPage />} />
                <Route path="/admin/settings" element={<AdminSettingsPage />} />
              </Route>
              
              {/* 404 Route */}
              <Route path="*" element={<NotFoundPage />} />
            </Routes>
          </Suspense>
        </MainLayout>
        
        {/* Toast notifications */}
        <Toaster
          position="top-right"
          toastOptions={{
            duration: 5000,
            style: {
              background: '#363636',
              color: '#fff',
            },
            success: {
              duration: 3000,
              iconTheme: {
                primary: '#4CAF50',
                secondary: '#fff',
              },
            },
            error: {
              duration: 4000,
              iconTheme: {
                primary: '#f44336',
                secondary: '#fff',
              },
            },
          }}
        />
      </AuthProvider>
    </Router>
  );
}

export default App;